import { IconTab } from "@/src/components/iconTab";
import { Hospitalisation, Patient, TransferDemand } from "@/src/data/allTypes";
import { getItemId, getUserId } from "@/src/utils/utils";
import { RiFolderTransferLine, RiUser2Line } from "react-icons/ri";
import { getStandardConfidentiality } from "../../patients/confidentialitiesHook";
import { openTransferDrawer } from "../transferDemands";

export default function TransferButton({
  patient,
  parent,
  onSave,
}: {
  patient: Patient;
  parent: Hospitalisation;
  onSave: (item: TransferDemand) => void;
}) {
  return (
    <IconTab
      id={"transfer"}
      activeTabId={null}
      isHorizontal={true}
      name={"Transfert"}
      icon={<RiFolderTransferLine size={20} />}
      onChange={async () => {
        let transfer: TransferDemand = {
          type: "transferDemand",
          status: "pending",
          notes: "",
          patient,
          parent: getItemId(parent),
          creator: getUserId(),
          acceptedBy: null,
          service: null,
          unit: null,
          exitDate: null,
          confidentiality: getStandardConfidentiality(patient),
          readBy: [getUserId()],
        };

        await openTransferDrawer(parent, transfer, (transfer) => {
          console.log("saved transfer", transfer);
          onSave(transfer);
        });
      }}
    />
  );
}
